import {
  buildWidgetCssVariables,
  type WidgetSurfaceColorsInput,
} from "@shared/widgets/cssVariables";
import type { WidgetPublicBranding } from "@shared/contracts/widgets/public/common";
import type {
  WidgetCardRadius,
  WidgetCardShadowDirection,
  WidgetCarouselTransitionDurationMs,
  WidgetMode,
} from "@shared/widgets/values";
import { WIDGET_STYLES } from "./css/styles";

export const MOUNTED_ATTRIBUTE = "data-mbn-wall-mounted";

export const isAlreadyMounted = (container: Element): boolean =>
  container.getAttribute(MOUNTED_ATTRIBUTE) === "true";

export const markMounted = (container: Element): void => {
  container.setAttribute(MOUNTED_ATTRIBUTE, "true");
};

export const ensureShadow = (container: HTMLElement): ShadowRoot => {
  if (container.shadowRoot) return container.shadowRoot;
  return container.attachShadow({ mode: "open" });
};

export type MountInput = {
  shadow: ShadowRoot;
  body: string;
  branding: WidgetPublicBranding;
  mode: WidgetMode;
  colors?: Omit<WidgetSurfaceColorsInput, "mode"> | undefined;
  cardRadius?: WidgetCardRadius | undefined;
  cardBorderWidth?: number | undefined;
  cardBorderColor?: string | null | undefined;
  cardShadowSize?: number | undefined;
  cardShadowDirections?: readonly WidgetCardShadowDirection[] | undefined;
  carouselTransitionDurationMs?: WidgetCarouselTransitionDurationMs | undefined;
};

export const renderShadow = ({
  shadow,
  body,
  branding,
  mode,
  colors,
  cardRadius,
  cardBorderWidth,
  cardBorderColor,
  cardShadowSize,
  cardShadowDirections,
  carouselTransitionDurationMs,
}: MountInput): void => {
  const variables = buildWidgetCssVariables({
    accentColor: branding.accentColor,
    fontFamily: branding.fontFamily,
    mode,
    backgroundColor: colors?.backgroundColor,
    cardColor: colors?.cardColor,
    textColor: colors?.textColor,
    cardRadius,
    cardBorderWidth,
    cardBorderColor,
    cardShadowSize,
    cardShadowDirections,
    carouselTransitionDurationMs,
  });
  const style = Object.entries(variables)
    .map(([key, value]) => `${key}: ${value};`)
    .join(" ");
  shadow.innerHTML = `<style>${WIDGET_STYLES}</style><div class="mbn-root" style="${style}" data-mode="${mode}">${body}</div>`;
};
